import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Books & Magazines',
  basePath: '/books',
  reorderable: true,
  columns: [
    { key: 'priority', label: 'Priority' },
    { key: 'book_type_name', label: 'Type' },
    { key: 'book_title', label: 'Product Name' },
    { key: 'book_price', label: 'Price' },
    { key: 'book_active', label: 'Active',
      render: (v) => v == 1 ? 'Yes' : 'No' },
    { key: 'book_new', label: 'New',
      render: (v) => v == 1 ? 'Yes' : 'No' },
    { key: 'book_free_pdf', label: 'Free PDF',
      render: (v) => v == 1 ? 'Yes' : 'No' },
  ],
  fields: [
    { key: 'book_kind', label: 'Type', type: 'async-select',
      optionsUrl: '/book-types/options',
      placeholder: 'Choose type', defaultValue: '1' },
    { key: 'book_active', label: 'Active', type: 'yesno', defaultValue: '0' },
    { key: 'book_new', label: 'New', type: 'yesno', defaultValue: '0' },
    { key: 'book_free_pdf', label: 'Free distribution', type: 'yesno', defaultValue: '0',
      fieldInfo: 'Please select yes if this item is offered as a free pdf or select no if item is in paid sale' },
    { key: 'book_title', label: 'Product name', type: 'text', required: true },
    { key: 'header', label: 'Main header', type: 'text',
      fieldInfo: "Used on portal's home page" },
    { key: 'book_info', label: 'Description', type: 'rich-text' },
    { key: 'photo', label: 'Photo', type: 'file', accept: 'image/*', photo: true },
    { key: 'pdf', label: 'PDF', type: 'file' },
    { key: 'book_price', label: 'Price', type: 'text',
      dependsOn: ['book_free_pdf'],
      visible: (v) => v.book_free_pdf != 1 },
    { key: 'book_link', label: 'Link', type: 'async-select',
      optionsUrl: '/articles/options',
      placeholder: 'Choose article' },
    { key: 'header1', label: 'Header 1', type: 'text' },
    { key: 'description1', label: 'Description 1', type: 'rich-text' },
    { key: 'header2', label: 'Header 2', type: 'text' },
    { key: 'description2', label: 'Description 2', type: 'rich-text' },
    { key: 'header3', label: 'Header 3', type: 'text' },
    { key: 'description3', label: 'Description 3', type: 'rich-text' },
  ],
});
